class RtcChatInfo {
    constructor() {
        // 当前通话内成员
        this.participant = new Map();
    }
    static fromVoipInfo(src, notfiedCalleeIds) {
        const info = new RtcChatInfo();
        info.userId = src.user_id.toString();
        info.deviceId = src.device_id;
        info.channelId = src.channel_id;
        info.token = src.token;
        info.voipStatus = src.status;
        info.callerId = src.caller_id.toString();
        info.createdTime = new Date(src.created_time_ms.toNumber());
        info.updatedTime = new Date(src.updated_time_ms.toNumber());
        info.conversationShortId = src.con_short_id.toString();
        info.voipType = src.v_type;
        info.serverMessageId = src.srv_msg_id.toString();
        info.participant = new Map();
        info.notifiedCalleeIds = [];
        if (notfiedCalleeIds !== undefined) {
            info.notifiedCalleeIds = notfiedCalleeIds.map(e => e.toString());
        }
        return info;
    }
    clone() {
        const info = new RtcChatInfo();
        info.userId = this.userId;
        info.deviceId = this.deviceId;
        info.channelId = this.channelId;
        info.token = this.token;
        info.voipStatus = this.voipStatus;
        info.callerId = this.callerId;
        info.createdTime = this.createdTime;
        info.updatedTime = this.updatedTime;
        info.conversationShortId = this.conversationShortId;
        info.voipType = this.voipType;
        info.serverMessageId = this.serverMessageId;
        info.participant = new Map(this.participant);
        info.chatDuration = this.chatDuration;
        info.notifiedCalleeIds = [...this.notifiedCalleeIds];
        return info;
    }
}

export { RtcChatInfo };
//# sourceMappingURL=RtcChatInfo.js.map
